import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import HelpIcon from '@material-ui/icons/Help'
import Tooltip from '@material-ui/core/Tooltip';

const HelpAdornment = ({ title }) => (
  <InputAdornment position='start'>
    <Tooltip title={title}>
      <HelpIcon color='action' fontSize='small'/>
    </Tooltip>
  </InputAdornment>
);

export default HelpAdornment;